import { useFlags } from './useFlags';

export const useFlagsmithMaintenance = () => {
  const flags = useFlags('maintenance_mode');
  const maintenanceFlag = flags.maintenance_mode;

  return {
    isMaintenanceMode: maintenanceFlag?.enabled || false,
    isLoading: false,
    error: null,
    refreshMaintenanceStatus: () => {
      // The useFlags hook handles updates automatically
      console.log('Flagsmith maintenance status:', maintenanceFlag);
    },
    featureFlagKey: 'maintenance_mode',
    flag: maintenanceFlag,
  };
};
